import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IGetItemsParams } from '../../../httpClient/serverApi/types/IGetItemsParams';
import { IGetItemsResult } from '../../../httpClient/serverApi/types/IGetItemsResult';
import { IDatasourceUsageInfo } from '../../../spacesPlatform/models/IUsageInfo';
import { INamedItem, ITypedItem } from '../../../spacesPlatform/models/resourceParts';
import { IUser } from '../../../userManagement/users/serverApi/types/IUser';
import { IDataSource } from '../types/IDataSource';

export interface IGetDatasourcesParams extends IGetItemsParams {
}

export interface IGetDatasourcesResult extends IGetItemsResult {
  datasources?: IDataSource[];
  projects?: INamedItem[];
  containers?: ITypedItem[];
  users?: IUser[];
  maxStats?: IDatasourceUsageInfo;
  favorites?: string[];
  workbooks?: INamedItem[];
}

export class GetDatasourcesRequest extends Request<IGetDatasourcesParams, IGetDatasourcesResult> {
  constructor(params: IGetDatasourcesParams) {
    super('getDatasources', params);
  }
}
